import { globalStoreCreator } from './store-creator'

interface IUser {
  follow_status: string // "not_followed", "followed", "requested"
}
export const { useState: useUserState, partialUpdateState: partialUpdateUser } =
  globalStoreCreator<IUser>()
